import { render, staticRenderFns } from "./outlook.vue?vue&type=template&id=5fb8b37e&scoped=true"
import script from "./outlook.vue?vue&type=script&lang=js"
export * from "./outlook.vue?vue&type=script&lang=js"
import style0 from "./outlook.vue?vue&type=style&index=0&id=5fb8b37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb8b37e",
  null
  
)

export default component.exports